import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { StockService } from '../../services/stock.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  private token:string;

  constructor(private _authService:AuthService, private _stockService:StockService) {
    this.token = "";
  }

  ngOnInit() {

  }

  onSignup(form:NgForm){
    const email = form.value.email;
    const password = form.value.password;
    let prov = {'email':email,'password':password};

    this._authService.save(prov).subscribe(
      response =>{
        //this.token = response.token;
        //console.log(this.token);
        this.onTest1();
        this.onTest2();
      }
    );
  }

  onTest1(){
    this._stockService.getStock2(this.token).subscribe( response => {
      console.log('response stock general');
      console.log(response);
    })
  }
  onTest2(){
    this._stockService.getStock3(this.token).subscribe( response => {
      console.log('response stock particular');
      console.log(response);
    })
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/auth/signup/signup.component.ts